// Adapted from https://dev.to/techcheck/custom-react-hook-usefetch-eid
import _ from "lodash";
import { useState, useEffect } from "react";
import originalAxios from "axios";
import fvAxios from "../utils/fvAxios";

const responseCache = {};

function useFetch(url, acceptCachedResponse = false, localhost = false,refresh=false) {
  const axios = localhost ? originalAxios : fvAxios;
  const [state, setState] = useState({
    data: null,
    error: null,
    loading: false,
  });

  useEffect(() => {
    if (!url) {
      setState({
        data: null,
        error: "URL not specified",
        loading: false,
      });
      return;
    }
    if (acceptCachedResponse && responseCache[url]) {
      setTimeout(() => {
        setState({ data: _.cloneDeep(responseCache[url]) });
      }, 0);
    } else {
      setState({
        data: null,
        error: null,
        loading: `fetching ${url.replace(/\?.*/, "")}`,
      });
      const controller = new AbortController();
      (async () => {
        try {
          const resp = await axios.get(url, {
            signal: controller.signal,
          });
          const data = _.isObject(resp.data)
            ? resp.data
            : JSON.parse(resp.data);
          responseCache[url] = _.cloneDeep(data);
          // setTimeout(() => {
            // setState({ data, error: null, loading: false });
          // }, 1000);
          setState({ data, error: null, loading: false });
        } catch (error) {
          // ERR_CANCELED is thrown on 'abort'. Ignore those
          if (error.code !== "ERR_CANCELED") {
            setState({
              data: null,
              error: `Error fetching ${url.replace(/\?.*/, "")}: ${
                error.message
              }`,
              loading: false,
            });
          }
          console.error(error);
        } finally {
          controller.abort("Completed");
        }
      })();
    }
  }, [url,refresh]);

  return state;
}

export default useFetch;
